import { Injectable } from "@angular/core";

@Injectable()
export class Globals {  
    culture: string = "en";
    cultureRoutingMatching: boolean = false;
    loading: boolean = false;
}